module.exports = __webpack_public_path__ + "assets/images/scene-2_bffae148baf452c6cbe3a1fd6c90aa56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/croma-abeldo-dialogs/scene-2.png
// module id = 245
// module chunks = 0